import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from 'react-hot-toast'
import { Modal } from "flowbite";
import { useNavigate } from "react-router-dom";

const ReferralConfig = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");

    const navigate = useNavigate();

    const [configuration, setConfiguration] = useState([]);

    const [referee, setReferee] = useState('');
    const [referrer, setReferrer] = useState('');
    const [referralAmount, setReferralAmount] = useState('');
    const [bonusTriggerCount, setBonusTriggerCount] = useState('');
    const [bonusAmount, setBonusAmount] = useState('');

    const [refreshKey, setRefreshKey] = useState(0);

    const [id, setId] = useState('');

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    useEffect(() => {
        const getConfiguration = async () => {
            try {
                const res = await axios.get(process.env.REACT_APP_API_URL + "api/referral/get-configuration", {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                setConfiguration(res.data.config);

            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                        setConfiguration(null);
                    }
                }
                setConfiguration(null);
            }
        }
        getConfiguration();

        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'referral'
            ));
        }
    }, [refreshKey])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            "refereeMultiplier": referee,
            "referrerMultiplier": referrer,
            "referralAmount": referralAmount,
            "bonusTriggerCount": bonusTriggerCount,
            "bonusAmount": bonusAmount,
        };

        try {
            const res = await axios.post(process.env.REACT_APP_API_URL + "api/referral/create-configuration", payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            setRefreshKey((prevKey) => prevKey + 1);
            toast.success(res.data.message);


        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(err.response.data); // Show other 400 errors
                }
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
        }
    };

    const getConfigData = async (config) => {
        const modalElement = document.getElementById("edit-modal");
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }

        setId(config.id);
        setReferee(config.refereeMultiplier);
        setReferrer(config.referrerMultiplier);
        setReferralAmount(config.referralAmount);
        setBonusTriggerCount(config.bonusTriggerCount);
        setBonusAmount(config.bonusAmount);
    }

    const updateConfig = async () => {
        try {
            const payload = {
                "refereeMultiplier": referee,
                "referrerMultiplier": referrer,
                "referralAmount": referralAmount,
                "bonusTriggerCount": bonusTriggerCount,
                "bonusAmount": bonusAmount,
            };
            const res = await axios.put(process.env.REACT_APP_API_URL + `api/referral/update-configuration/${id}`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            if (res.data.success) {
                toast.success(res.data.message);
                setRefreshKey((prevKey) => prevKey + 1);
            }
        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    sessionStorage.clear();
                    navigate("/"); // Redirect to login page
                } else {
                    console.error(err.response.data); // Show other 400 errors
                }
            }
        }
    }

    useEffect(() => {
        // Initialize the modal on component mount
        const modalElement = document.getElementById("edit-modal");
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.hide(); // Ensure the modal is initially hidden
        }

        // Initialize the modal on component mount
        const createElement = document.getElementById("popup-modal");
        if (createElement) {
            const create_modal = new Modal(createElement);
            create_modal.hide(); // Ensure the modal is initially hidden
        }
    }, []);

    return (
        <div className="bg-gray-100">
            <div className="py-20 sm:ml-64 p-6 rounded-lg shadow-md">

                <div className="md:flex justify-between py-5">

                    {
                        permissionModule.canCreate &&
                        <button type="button"
                            onClick={() => {
                                const createElement = document.getElementById("popup-modal");
                                if (createElement) {
                                    const create_modal = new Modal(createElement);
                                    create_modal.show();
                                }
                            }}
                            className="flex text-white bg-black rounded-full px-5 py-2 my-5">Create New configuration</button>
                    }
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md ">
                    <h2 className="text-xl md:text-3xl text-left font-semibold mb-10">Referral Configuration</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Referee</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Referrer</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Referral Amount</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Bonus Count</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Bonus Amount</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {configuration ? (
                                    permissionModule.canRead ? configuration.map((config) => (
                                        <tr key={config.id} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{config.refereeMultiplier}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{config.referrerMultiplier}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{config.referralAmount}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{config.bonusTriggerCount}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{config.bonusAmount}</td>
                                            {permissionModule?.canUpdate && (
                                                <td className="px-6 py-4 whitespace-normal break-words">
                                                    <button type="button" onClick={() => getConfigData(config)} className="text-white py-1 px-4 bg-black rounded-full">Edit</button>
                                                </td>
                                            )}
                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4 whitespace-normal break-words">No Configuration Found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div
                id="popup-modal"
                tabIndex={-1}
                className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
            >
                <div className="relative p-4 w-full max-w-4xl max-h-[60%]">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <button
                            type="button"
                            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                const createElement = document.getElementById("popup-modal");
                                if (createElement) {
                                    const create_modal = new Modal(createElement);
                                    create_modal.hide();
                                }
                            }}
                        >
                            <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-4  text-center">
                            <div className=" p-6 bg-white shadow rounded-lg">
                                <h2 className="text-2xl font-bold text-center mb-6">Create New Configuration</h2>
                                <form onSubmit={handleSubmit} className="space-y-4">

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-left">

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referee Multiplier</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referee}
                                                onChange={(e) => setReferee(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referrer Multiplier</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referrer}
                                                onChange={(e) => setReferrer(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referral Amount</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referralAmount}
                                                onChange={(e) => setReferralAmount(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Bonus Trigger</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={bonusTriggerCount}
                                                onChange={(e) => setBonusTriggerCount(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Bonus Amount</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={bonusAmount}
                                                onChange={(e) => setBonusAmount(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>

                                    <div className="mt-5 flex justify-end">

                                        <button
                                            type="submit"
                                            className="bg-black cursor-pointer text-white px-4 py-2 rounded-full"
                                        >
                                            Save
                                        </button>
                                    </div>


                                </form>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            {/* edit modal */}
            <div
                id="edit-modal"
                tabIndex={-1}
                className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
            >
                <div className="relative p-4 w-full max-w-4xl max-h-[60%]">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <button
                            type="button"
                            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                const modalElement = document.getElementById("edit-modal");
                                if (modalElement) {
                                    const modal = new Modal(modalElement);
                                    modal.hide();
                                }
                            }}
                        >
                            <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-4  text-center">
                            <div className=" p-6 bg-white shadow rounded-lg">
                                <h2 className="text-2xl font-bold text-center mb-6">Edit Configuration</h2>
                                <form onSubmit={updateConfig}>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-left">

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referee Multiplier</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referee}
                                                onChange={(e) => setReferee(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referrer Multiplier</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referrer}
                                                onChange={(e) => setReferrer(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Referral Amount</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={referralAmount}
                                                onChange={(e) => setReferralAmount(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Bonus Trigger</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={bonusTriggerCount}
                                                onChange={(e) => setBonusTriggerCount(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Bonus Amount</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={bonusAmount}
                                                onChange={(e) => setBonusAmount(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>

                                    <div className="mt-5 flex justify-end">



                                        <div>

                                            <button
                                                type="submit"
                                                className="text-white bg-black rounded-full text-sm inline-flex items-center px-5 py-2.5 text-center"
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => {
                                                    const modalElement = document.getElementById("edit-modal");
                                                    if (modalElement) {
                                                        const modal = new Modal(modalElement);
                                                        modal.hide();
                                                    }
                                                }}
                                                type="button"
                                                className="py-2.5 px-5 ms-3 text-sm font-medium text-black focus:outline-none bg-white rounded-full border border-black hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReferralConfig;